import { Kbd } from "@mantine/core";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { useImagePreviewHandlers } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";
import { Group } from "../../../group";

/**
 * Close tool for the ImagePreview toolbox. Closes the preview modal.
 */
export const Close = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();

    return (
        <Tool
            icon={faXmark}
            label={
                <Group wrap="nowrap">
                    Close <Kbd>Esc</Kbd>
                </Group>
            }
            onClick={handlers.close}
            {...props}
        />
    );
};
